export const gitCommit = '538cd97a'
